module.exports = __webpack_public_path__ + "img/frutika.35832bba.jpg";